import { render, staticRenderFns } from "./CustomerStatementView.vue?vue&type=template&id=483a4d12&scoped=true"
import script from "./CustomerStatementView.vue?vue&type=script&lang=js"
export * from "./CustomerStatementView.vue?vue&type=script&lang=js"
import style0 from "./CustomerStatementView.vue?vue&type=style&index=0&id=483a4d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483a4d12",
  null
  
)

export default component.exports